module.exports = __webpack_public_path__ + "static/media/404@2x.bc77b0de.png";